import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore } from "../hooks/useAuthStore";
import LoadingSpinner from "../components/LoadingSppiner";
import { subscribeUser } from "../services/PushSubscriptionService";

export default function LoginRoute() {
  const { user, isAuthenticated, isHydrated, getRedirectPath } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      subscribeUser();
    }
  }, [isAuthenticated, user]);

  if (!isHydrated) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={getRedirectPath()} replace />;
  }

  return <Outlet />;
}